// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
export type TrustBeneficiariesList_ScheduledDistributionFragment = { __typename?: 'ScheduledDistribution', id: string, ageRequirementEnd?: number | null, ageRequirementStart?: number | null, amount?: CurrencyUSD | null, frequency?: Types.ScheduledDistributionFrequency | null, growByInflation: boolean, kind: Types.ScheduledDistributionKind, percentage?: Percent | null };

export type TrustBeneficiariesList_AccessAgeParameterFragment = { __typename?: 'AccessAgeParameter', id: string, ageRequirementEnd?: number | null, ageRequirementStart?: number | null, notes?: string | null };

export type TrustBeneficiariesList_AccessParameterFragment = { __typename?: 'AccessParameter', id: string, amount?: CurrencyUSD | null, frequency?: Types.AccessParameterFrequency | null, kind: Types.AccessParameterKind, percentage?: Percent | null, accessAgeParameters: { __typename?: 'AccessAgeParameterConnection', edges?: Array<{ __typename?: 'AccessAgeParameterEdge', node?: (
        { __typename?: 'AccessAgeParameter' }
        & TrustBeneficiariesList_AccessAgeParameterFragment
      ) | null } | null> | null } };

export type TrustBeneficiariesList_BeneficiaryFragment = { __typename?: 'Beneficiary', id: string, kind?: Types.BeneficiaryKind | null, level?: Types.BeneficiaryLevel | null, notes?: string | null, scheduledDistributions: { __typename?: 'ScheduledDistributionConnection', edges?: Array<{ __typename?: 'ScheduledDistributionEdge', node?: (
        { __typename?: 'ScheduledDistribution' }
        & TrustBeneficiariesList_ScheduledDistributionFragment
      ) | null } | null> | null }, accessParameters: { __typename?: 'AccessParameterConnection', edges?: Array<{ __typename?: 'AccessParameterEdge', node?: (
        { __typename?: 'AccessParameter' }
        & TrustBeneficiariesList_AccessParameterFragment
      ) | null } | null> | null }, individual?: { __typename?: 'ClientProfile', id: string, displayName: string, household: { __typename?: 'Household', id: string } } | null, entity?: { __typename?: 'Entity', id: string, stage: Types.EntityStage, extendedDisplayKind: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string }, household: { __typename?: 'Household', id: string } } | null, organization?: { __typename?: 'ClientOrganization', id: string, name: string, household: { __typename?: 'Household', id: string } } | null, testamentaryEntity?: { __typename?: 'TestamentaryEntity', id: string, displayName: string, household: { __typename?: 'Household', id: string } } | null };

export const Operations = {
  Fragment: {
    TrustBeneficiariesList_ScheduledDistribution: 'TrustBeneficiariesList_ScheduledDistribution' as const,
    TrustBeneficiariesList_AccessAgeParameter: 'TrustBeneficiariesList_AccessAgeParameter' as const,
    TrustBeneficiariesList_AccessParameter: 'TrustBeneficiariesList_AccessParameter' as const,
    TrustBeneficiariesList_Beneficiary: 'TrustBeneficiariesList_Beneficiary' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const TrustBeneficiariesList_ScheduledDistributionFragmentDoc = gql`
    fragment TrustBeneficiariesList_ScheduledDistribution on ScheduledDistribution {
  id
  ageRequirementEnd
  ageRequirementStart
  amount
  frequency
  growByInflation
  kind
  percentage
}
    `;
export const TrustBeneficiariesList_AccessAgeParameterFragmentDoc = gql`
    fragment TrustBeneficiariesList_AccessAgeParameter on AccessAgeParameter {
  id
  ageRequirementEnd
  ageRequirementStart
  notes
}
    `;
export const TrustBeneficiariesList_AccessParameterFragmentDoc = gql`
    fragment TrustBeneficiariesList_AccessParameter on AccessParameter {
  id
  accessAgeParameters {
    edges {
      node {
        ...TrustBeneficiariesList_AccessAgeParameter
      }
    }
  }
  amount
  frequency
  kind
  percentage
}
    ${TrustBeneficiariesList_AccessAgeParameterFragmentDoc}`;
export const TrustBeneficiariesList_BeneficiaryFragmentDoc = gql`
    fragment TrustBeneficiariesList_Beneficiary on Beneficiary {
  id
  kind
  level
  notes
  scheduledDistributions {
    edges {
      node {
        ...TrustBeneficiariesList_ScheduledDistribution
      }
    }
  }
  accessParameters {
    edges {
      node {
        ...TrustBeneficiariesList_AccessParameter
      }
    }
  }
  individual {
    id
    displayName
    household {
      id
    }
  }
  entity {
    id
    stage
    extendedDisplayKind
    subtype {
      id
      displayName
    }
    household {
      id
    }
  }
  organization {
    id
    name
    household {
      id
    }
  }
  testamentaryEntity {
    id
    displayName
    household {
      id
    }
  }
}
    ${TrustBeneficiariesList_ScheduledDistributionFragmentDoc}
${TrustBeneficiariesList_AccessParameterFragmentDoc}`;